<template>
	<div id="app" ondragstart="return false">
		<router-view/>
	</div>
</template>

<script>
export default {
	name: "app",
	components: {}
};
</script>

<style>
#app {
	font-family: 'Noto Sans JP', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: #262728;
	color: #fff;
}
</style>
